import React from "react";
import coatOfArms from "../assets/images/coat_of_arms.png";
import '../styles/header.css';
import Translator from "../services/Translator";


export default function Header({lang, text, securityStatus, setScreen, setText}: any) {
    return (
        <div id="header" className={"security-" + securityStatus.type}>
            <div className="container">
                <div className="row">
                    <div className="col-2">
                        <img
                            src={coatOfArms}
                            alt={Translator.trans(lang, 'name')}
                            className="logo"
                            style={{width: 'auto', height: '40px', cursor: 'pointer'}}
                            onClick={() => {setScreen('home'); setText(Translator.trans(lang, 'name'));}}
                        />
                    </div>

                    <div className="col-8 title" style={{textAlign: 'center'}}>
                        {(text === null ? '' : text)}
                    </div>

                    <div className="col-2">
                        <span className="semicoln" onClick={() => {setScreen('information'); setText(Translator.trans(lang, 'navigation.information'));}}>!</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
